module.exports = require("eth-lib/lib/account");